import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbCollapseModule, NgbDatepickerModule, NgbModalModule, NgbNavModule, NgbPaginationModule, NgbProgressbarModule, NgbTimepickerModule, NgbTooltipModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { BaseAuthModule, ElbuildUiLibModule, PipesModule } from 'elbuild-ui-lib-core';
import { ElbuildCoreComponentsModule } from 'elbuild-ui-componentslib';
import { QuillModule } from 'ngx-quill';
import { ProjectViewComponent } from 'src/app/@core/core-components/project/project-view/project-view.component';
import { SharedModule } from 'src/app/theme/shared/shared.module';

import { ActivitiesResourcesComponent } from './activities-resources/activities-resources.component';
import { ActivityEditComponent } from './activity/activity-edit/activity-edit.component';
import { ActivityListFiltersComponent } from './activity/activity-list/activity-list-filters/activity-list-filters.component';
import { ActivityListComponent } from './activity/activity-list/activity-list.component';
import { ActivityViewComponent } from './activity/activity-view/activity-view.component';
import { ActivitykpiEditComponent } from './activitykpi/activitykpi-edit/activitykpi-edit.component';
import { ActivitykpiListComponent } from './activitykpi/activitykpi-list/activitykpi-list.component';
import { AgendaComponent } from './agenda/agenda.component';
import { BuildingEditComponent } from './building/building-edit/building-edit.component';
import { BuildingListFiltersComponent } from './building/building-list/building-list-filters/building-list-filters.component';
import { BuildingListComponent } from './building/building-list/building-list.component';
import { BuildingViewComponent } from './building/building-view/building-view.component';
import { ConsultantresourceEditComponent } from './consultantresource/consultantresource-edit/consultantresource-edit.component';
import { ConsultantresourceListFiltersComponent } from './consultantresource/consultantresource-list/consultantresource-list-filters/consultantresource-list-filters.component';
import { ConsultantresourceListComponent } from './consultantresource/consultantresource-list/consultantresource-list.component';
import { ConsultantresourceViewComponent } from './consultantresource/consultantresource-view/consultantresource-view.component';
import { DeliverableAttachmentsComponent } from './deliverable/deliverable-attachments/deliverable-attachments.component';
import { DeliverableEditComponent } from './deliverable/deliverable-edit/deliverable-edit.component';
import { DeliverableListComponent } from './deliverable/deliverable-list/deliverable-list.component';
import { EmployeeListFiltersComponent } from './employee/employee-list/employee-list-filters/employee-list-filters.component';
import { EmployeeListComponent } from './employee/employee-list/employee-list.component';
import { EmployeePersonalEditComponent } from './employee/employee-personal-edit/employee-personal-edit.component';
import { EmployeeSalaryEditComponent } from './employee/employee-salary-edit/employee-salary-edit.component';
import { EmployeeViewComponent } from './employee/employee-view/employee-view.component';
import { HoursResourcesComponent } from './hours-resources/hours-resources.component';
import { MilestoneEditComponent } from './milestone/milestone-edit/milestone-edit.component';
import { MilestoneListComponent } from './milestone/milestone-list/milestone-list.component';
import { ObjectiveEditComponent } from './objective/objective-edit/objective-edit.component';
import { ObjectiveListFiltersComponent } from './objective/objective-list/objective-list-filters/objective-list-filters.component';
import { ObjectiveListComponent } from './objective/objective-list/objective-list.component';
import { ObjectiveViewComponent } from './objective/objective-view/objective-view.component';
import { OwnerEditComponent } from './owner/owner-edit/owner-edit.component';
import { OwnerListFiltersComponent } from './owner/owner-list/owner-list-filters/owner-list-filters.component';
import { OwnerListComponent } from './owner/owner-list/owner-list.component';
import { OwnerViewComponent } from './owner/owner-view/owner-view.component';
import { PartecipantEditComponent } from './partecipant/partecipant-edit/partecipant-edit.component';
import { PartecipantListComponent } from './partecipant/partecipant-list/partecipant-list.component';
import { ProjectBuildingAddComponent } from './project-building/project-building-add/project-building-add.component';
import { ProjectBuildingListComponent } from './project-building/project-building-list/project-building-list.component';
import { ProjectBuildingsComponent } from './project-building/project-buildings/project-buildings.component';
import { ProjectEmployeeAddComponent } from './project-employee/project-employee-add/project-employee-add.component';
import { ProjectEmployeeListComponent } from './project-employee/project-employee-list/project-employee-list.component';
import { ProjectToolAddComponent } from './project-tool/project-tool-add/project-tool-add.component';
import { ProjectToolListComponent } from './project-tool/project-tool-list/project-tool-list.component';
import { ProjectToolsComponent } from './project-tool/project-tools/project-tools.component';
import { ProjectConsultantsAddComponent } from './project/project-consultants/project-consultants-add/project-consultants-add.component';
import { ProjectConsultantsComponent } from './project/project-consultants/project-consultants.component';
import { ProjectEditComponent } from './project/project-edit/project-edit.component';
import { ProjectListFiltersComponent } from './project/project-list/project-list-filters/project-list-filters.component';
import { ProjectListComponent } from './project/project-list/project-list.component';
import { TenderEditComponent } from './tender/tender-edit/tender-edit.component';
import { TenderListFiltersComponent } from './tender/tender-list/tender-list-filters/tender-list-filters.component';
import { TenderListComponent } from './tender/tender-list/tender-list.component';
import { TenderViewComponent } from './tender/tender-view/tender-view.component';
import { TimesheetEditModalComponent } from './timesheet-grid/timesheet-edit-modal/timesheet-edit-modal.component';
import { TimesheetGridComponent } from './timesheet-grid/timesheet-grid.component';
import { ToolEditComponent } from './tool/tool-edit/tool-edit.component';
import { ToolListFiltersComponent } from './tool/tool-list/tool-list-filters/tool-list-filters.component';
import { ToolListComponent } from './tool/tool-list/tool-list.component';
import { ToolViewComponent } from './tool/tool-view/tool-view.component';
import { UserListFiltersComponent } from './user/user-list/user-list-filters/user-list-filters.component';
import { UserListComponent } from './user/user-list/user-list.component';
import { UserNewEditComponent } from './user/user-new-edit/user-new-edit.component';
import { ListListComponent } from './list/list-list/list-list.component';
import { ProjectdataEditComponent } from './project/projectdata-edit/projectdata-edit.component';
import { ProjectCostsummaryComponent } from './project/project-costsummary/project-costsummary.component';
import { ListItemListComponent } from './list/list-item-list/list-item-list.component';
import { ListItemEditComponent } from './list/list-item-edit/list-item-edit.component';
import { ProjectCostsListComponent } from './project/project-costs/project-costs-list/project-costs-list.component';
import { ProjectCostsEditComponent } from './project/project-costs/project-costs-edit/project-costs-edit.component';
import { ConfListComponent } from './conf/conf-list/conf-list.component';
import { ConfEditComponent } from './conf/conf-edit/conf-edit.component';
import { ConfListFiltersComponent } from './conf/conf-list/conf-list-filters/conf-list-filters.component';
import { UserRolesComponent } from './user/user-roles/user-roles.component';
import { DoctemplateListComponent } from './doctemplate/doctemplate-list/doctemplate-list.component';
import { DoctemplateEditComponent } from './doctemplate/doctemplate-edit/doctemplate-edit.component';
import { DoctemplateListFiltersComponent } from './doctemplate/doctemplate-list/doctemplate-list-filters/doctemplate-list-filters.component';

import { DocTemplateGenerateComponent } from './doc-template-generate/doc-template-generate.component';
import { ProjectGantt } from 'toolbandi-ui-lib';
import { ProjectGanttComponent } from './project/project-gantt/project-gantt.component';
import { TextblockEditComponent } from './tender/textblock/textblock-edit/textblock-edit.component';
import { TextblockListFiltersComponent } from './tender/textblock/textblock-list/textblock-list-filters/textblock-list-filters.component';
import { TextblockListComponent } from './tender/textblock/textblock-list/textblock-list.component';
import { AdditionalSectionsComponent } from './additional-sections/additional-sections.component';
import { EmployeePrecenceupdateComponent } from './employee/employee-view/employee-precenceupdate/employee-precenceupdate.component';
import { ToolActivityUseComponent } from './tool/tool-activity-use/tool-activity-use.component';
import { Ng5SliderModule } from 'ng5-slider';
import { BuildingActivityUseComponent } from './building/building-activity-use/building-activity-use.component';
import { ConsultantresourcePresenceupdateComponent } from './consultantresource/consultantresource-presenceupdate/consultantresource-presenceupdate.component';

// tslint:disable-next-line:max-line-length



@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		NgbTooltipModule,
		NgbPaginationModule,
		NgbTypeaheadModule,
		NgbDatepickerModule,
		NgbTimepickerModule,
		RouterModule,
		PipesModule,
		BaseAuthModule,
		ElbuildCoreComponentsModule,
		SharedModule,
		NgxDatatableModule,
		TranslateModule.forChild(),
		NgbCollapseModule,
		NgbNavModule,

		NgbModalModule,
		QuillModule,
		ElbuildUiLibModule,
		Ng5SliderModule,
		NgbProgressbarModule
	],
	exports: [
		EmployeeViewComponent,
		EmployeeListComponent,
		EmployeeListFiltersComponent,
		OwnerListComponent,
		OwnerListFiltersComponent,
		OwnerEditComponent,
		OwnerViewComponent,
		BuildingListComponent,
		BuildingEditComponent,
		BuildingListFiltersComponent,
		BuildingViewComponent,
		ToolEditComponent,
		ToolListComponent,
		ToolListFiltersComponent,
		ToolViewComponent,
		UserListComponent,
		UserListFiltersComponent,
		UserNewEditComponent,
		TenderEditComponent,
		TenderListComponent,
		TenderListFiltersComponent,
		TenderViewComponent,
		ProjectListComponent,
		ProjectEditComponent,
		ProjectListFiltersComponent,
		ProjectViewComponent,
		ConsultantresourceEditComponent,
		ConsultantresourceListComponent,
		ConsultantresourceListFiltersComponent,
		ConsultantresourceViewComponent,
		ObjectiveEditComponent,
		ObjectiveListComponent,
		ObjectiveListFiltersComponent,
		ObjectiveViewComponent,
		ActivityEditComponent,
		ActivityListComponent,
		ActivityListFiltersComponent,
		ActivityViewComponent,
		MilestoneEditComponent,
		MilestoneListComponent,
		DeliverableListComponent,
		DeliverableEditComponent,
		DeliverableAttachmentsComponent,
		PartecipantListComponent,
		PartecipantEditComponent,
		ActivitykpiListComponent,
		ActivitykpiEditComponent,
		ProjectEmployeeListComponent,
		ProjectEmployeeAddComponent,
		ProjectBuildingAddComponent,
		ProjectBuildingListComponent,
		ProjectToolAddComponent,
		ProjectToolListComponent,
		ActivitiesResourcesComponent,
		EmployeePersonalEditComponent,
		EmployeeSalaryEditComponent,
		HoursResourcesComponent,
		ProjectToolsComponent,
		ProjectBuildingsComponent,
		ProjectConsultantsAddComponent,
		ProjectConsultantsComponent,
		ListListComponent,
		ProjectdataEditComponent,
		ListItemListComponent,
		ListItemEditComponent,
		ProjectCostsListComponent,
		ProjectCostsEditComponent,
		ConfListComponent,
		ConfEditComponent,
		ConfListFiltersComponent,
		UserRolesComponent,
		DocTemplateGenerateComponent,
		AdditionalSectionsComponent,
		EmployeePrecenceupdateComponent
	],
	declarations: [
		EmployeeViewComponent,
		EmployeeListComponent,
		EmployeeListFiltersComponent,
		OwnerListComponent,
		OwnerListFiltersComponent,
		OwnerEditComponent,
		OwnerViewComponent,
		BuildingListComponent,
		BuildingEditComponent,
		BuildingListFiltersComponent,
		BuildingViewComponent,
		ToolEditComponent,
		ToolListComponent,
		ToolListFiltersComponent,
		ToolViewComponent,
		UserListComponent,
		UserListFiltersComponent,
		UserNewEditComponent,
		TenderEditComponent,
		TenderListComponent,
		TenderListFiltersComponent,
		TenderViewComponent,
		ProjectListComponent,
		ProjectEditComponent,
		ProjectListFiltersComponent,
		ProjectViewComponent,
		ConsultantresourceEditComponent,
		ConsultantresourceListComponent,
		ConsultantresourceListFiltersComponent,
		ConsultantresourceViewComponent,
		ObjectiveEditComponent,
		ObjectiveListComponent,
		ObjectiveListFiltersComponent,
		ObjectiveViewComponent,
		ActivityEditComponent,
		ActivityListComponent,
		ActivityListFiltersComponent,
		ActivityViewComponent,
		MilestoneEditComponent,
		MilestoneListComponent,
		DeliverableListComponent,
		DeliverableEditComponent,
		DeliverableAttachmentsComponent,
		PartecipantListComponent,
		PartecipantEditComponent,
		ActivitykpiListComponent,
		ActivitykpiEditComponent,
		ProjectEmployeeListComponent,
		ProjectEmployeeAddComponent,
		ProjectBuildingAddComponent,
		ProjectBuildingListComponent,
		ProjectToolAddComponent,
		ProjectToolListComponent,
		ActivitiesResourcesComponent,
		EmployeePersonalEditComponent,
		EmployeeSalaryEditComponent,
		HoursResourcesComponent,
		HoursResourcesComponent,
		ProjectToolsComponent,
		ProjectBuildingsComponent,
		ProjectConsultantsAddComponent,
		ProjectConsultantsComponent,
		AgendaComponent,
		TimesheetGridComponent,
		TimesheetEditModalComponent,
		ListListComponent,
		ProjectdataEditComponent,
		ProjectCostsummaryComponent,
		ListItemListComponent,
		ListItemEditComponent,
		ProjectCostsListComponent,
		ProjectCostsEditComponent,
		ConfListComponent,
		ConfEditComponent,
		ConfListFiltersComponent,
		UserRolesComponent,
		DoctemplateListComponent,
		DoctemplateEditComponent,
		DoctemplateListFiltersComponent,
		TextblockListComponent,
		TextblockListFiltersComponent,
		TextblockEditComponent,
		ProjectGanttComponent,
		DocTemplateGenerateComponent,
		AdditionalSectionsComponent,
		EmployeePrecenceupdateComponent,
		ToolActivityUseComponent,
		BuildingActivityUseComponent,
		ConsultantresourcePresenceupdateComponent
	],

	providers: [],
	entryComponents: [
		TimesheetEditModalComponent
	]
})
export class CoreComponentsModule {
}
